import { FormControl } from "@angular/forms";

export class PasswordValidator {
  public static strong(control: FormControl) {
    const hasNumber = /\d/.test(control.value);
    const hasUpper = /[A-Z]/.test(control.value);
    const hasLower = /[a-z]/.test(control.value);
    const hasProperLength = control.value && control.value.length >= 8;
    const valid = hasNumber && hasUpper && hasLower && hasProperLength;
    if (!valid) {
      return { strong: { value: control.value } };
    }

    return null;
  }
}
